import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi, type ReturnsDashboard } from '../../api/returns';

const NAV = [
  { to: '/returns/list', label: 'Returns' },
  { to: '/returns/rma', label: 'RMA' },
  { to: '/returns/refunds', label: 'Refunds' },
  { to: '/returns/reverse', label: 'Reverse logistics' },
  { to: '/returns/claims', label: 'Claims' },
  { to: '/returns/rto', label: 'RTO' },
  { to: '/returns/analytics', label: 'Analytics' },
];

export function ReturnsHubPage() {
  const [dashboard, setDashboard] = useState<ReturnsDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void returnsApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total returns', value: dashboard.total_returns },
        { label: 'Pending approval', value: dashboard.pending_approval },
        { label: 'In transit', value: dashboard.in_transit },
        { label: 'Refunds', value: dashboard.total_refunds },
        { label: 'Open claims', value: dashboard.open_claims },
        { label: 'RTO count', value: dashboard.rto_count },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Returns & Reverse Logistics</h1>
      <p className="mt-1 text-sm text-slate-600">RMA, refunds, reverse pickup, claims and RTO management.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
